import { useAuth } from '../../context/AuthContext';
import { useCandidatoContext } from '../../context/CandidatoContext';
import SelectBusca from '../form/SelectBusca';

export default function CandidatoSelectorHeader() {
  const { user } = useAuth();
  const { candidatos, candidatosPermitidos, selecionado, carregando, mudarCandidato } = useCandidatoContext();
  const ehAdmin = user?.role === 'admin';

  if (!ehAdmin || carregando) return null;

  // Se admin tem restrição, mostra só os permitidos; senão, mostra todos
  const candidatosVisiveis = candidatosPermitidos.length > 0
    ? candidatos.filter(c => candidatosPermitidos.includes(c.id))
    : candidatos;

  // Opções: "Admin (sem filtro)" + lista de candidatos permitidos
  const opcoes = [
    { value: 'admin', label: 'Admin (sem filtro)' },
    ...candidatosVisiveis.map(c => ({ value: String(c.id), label: c.nome }))
  ];

  const valor = selecionado === null ? 'admin' : String(selecionado);

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-medium text-gray-600 dark:text-gray-400 hidden sm:inline">Contexto:</span>
      <div className="w-56 sm:w-48">
        <SelectBusca
          options={opcoes}
          value={valor}
          onChange={(val) => mudarCandidato(val === 'admin' ? null : Number(val))}
          placeholder="Selecione..."
          isClearable={false}
          isMulti={false}
        />
      </div>
    </div>
  );
}
